export default {
  name: 'date-picker',
  label: '日期',
  dataType: 'date',
  icon: 'el-icon-date',
  config: [{
    // 可修改的配置选项
    xtype: 'text',
    options: {
      label: '输入提示',
      name: 'placeholder',
      default: '请选择日期'
    }
  }, {
    xtype: 'text',
    options: {
      label: '展示格式',
      tip: '前端展示格式，可任意设置',
      name: 'format',
      default: 'yyyy-MM-dd'
    }
  }, {
    xtype: 'text',
    options: {
      label: '存储格式',
      tip: '后端保存格式，必须为可转为日期对象的字符串',
      name: 'valueFormat',
      default: 'yyyy-MM-dd'
    }
  }]
};